import React from "react";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <section className="term-and-condition">
      <div className="banner">
        <div className="about-text">
          <h1>Terms and Conditions </h1>
        </div>
      </div>
      <div className="term-center">
        <div className="term-heading">
          <h2>Terms & Conditions</h2>
        </div>
        <div className="main-para-term">
          <h3>
            PLEASE READ THIS AGREEMENT CAREFULLY. IT SETS FORTH THE LEGALLY
            BINDING TERMS AND CONDITIONS FOR YOUR ACCESS TO AND USE OF THE
            SERVICE (DEFINED BELOW).
          </h3>
        </div>
        <div className="term-top">
          <div className="term-left">
            <div className="term-img">
              <img src="/images/service-summary-1.png" alt="" />
            </div>
          </div>
          <div className="term-right">
            <div className="term-text">
              <h2>Introduction</h2>
              <p>
                Welcome! These Terms of Use <span>(“Terms”)</span> govern your
                access to and use of the websites (including both mobile and
                online versions), online and mobile services (e.g., apps), and
                software made available by LineConsultant{" "}
                <span>(“LineConsultant”, “we” “our” or “us”)</span>, including
                interactive features, widgets, plug-ins, applications, content,
                downloads and/or other services that we own and control and that
                post a link to these Terms (collectively, the 
                <span>“Service”</span>), regardless of how you access or use the
                Service, whether via computer, mobile device or otherwise. The
                term “you” or ““your” refers to the person or entity accessing
                or using the Service. By using the Service, you acknowledge and
                accept the Service’s 
                <a href="https://en.caillou.com/privacy-policy">
                  Privacy & Cookies Policy
                </a>
                 and consent to the collection, disclosure, storage and use of
                your data in accordance with the 
                <a href="https://en.caillou.com/privacy-policy">
                  Privacy & Cookies Policy.
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="term-buttom">
          <div className="term-text">
            <h2>If You Want to Use the Service,</h2>
            <p>
              Then carefully read these entire Terms (including all links to
              details), as they constitute a written agreement between you and
              us and they affect your legal rights and obligations. Each time
              you access and/or use the Service (other than to simply read these
              Terms), you agree to be bound by and comply with these Terms and
              any Additional Terms (defined below) then posted. Therefore, do
              not use the Service if you do not agree. If you are under the age
              of majority in your province, state or jurisdiction of residence,
              you may use the Service only with involvement of a parent or
              guardian who agrees to these Terms and to be responsible for your
              use.
            </p>
            <p>
              The business realities associated with operating the Service are
              such that, without the limitations that are set forth in these
              Terms, such as your grants and waivers of rights, the limitations
              on our liability, your indemnity of us, and the arbitration of
              certain disputes – we would not make the Service available to you.
            </p>
            <p>
              By installing, downloading, accessing, or otherwise using the
              Service, you agree to be bound by these Terms. In some instances,
              both these Terms and separate guidelines, rules, or terms of use
              or sale setting forth additional or different terms and/or
              conditions will apply to your use of the Service or to a service
              or product offered via the Service (in each such instance, and
              collectively “Additional Terms”). To the extent there is a
              conflict between these Terms and any Additional Terms, the
              Additional Terms will control unless the Additional Terms
              expressly state otherwise. Additionally, certain features and
              services made available through the Service from time to time may
              be governed by different terms of use.
            </p>
            <h2>Terms of Use Table of Contents and Summary</h2>
            <p>
              It is important that you read and understand these entire Terms
              before using the Service. To ease review, each section below
              includes a brief introductory summary and a link to the full
              explanation. Please note that the complete provisions, and not the
              headings or summaries shall govern. You can click on the headings
              and “More” buttons to be taken to the full explanation. Any
              capitalized terms have the meanings given to them where defined in
              the Terms.
            </p>
            <ul>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Service Content, Ownership, Limited License and Rights of
                  Others
                </a>
              </li>
              <p>
                We only grant you a limited revocable license to use the Service
                for your own non-commercial use subject to rules and
                limitations.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Service and Content Use Restrictions
                </a>
              </li>
              <p>
                Your use of our Service is subject to various restrictions
                designed to protect the Service and our users. We may change or
                discontinue our Service in whole or in part.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Opening and Terminating Accounts
                </a>
              </li>
              <p>You may open, revise, and close your accounts.</p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Content You Submit and Community Usage Rules
                </a>
              </li>
              <p>
                You grant us a broad license, which we may sublicense, to the
                content you submit which you represent you have the right to
                allow us to use. You, however, retain ownership of and
                responsibility for, your content. Use of our Service is subject
                to community usage rules and we have the right to manage our
                Service to keep its content appropriate.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Procedure For Alleging Copyright Infringement
                </a>
              </li>
              <p>
                Users may not post content they do not own or control, and may
                be suspended or terminated if they do so. Copyright owners may
                give us notice of infringement by following specific
                instructions specifically addressed in this Section.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Procedure For Alleging Infringement of Other Intellectual
                  Property
                </a>
              </li>
              <p>
                You can also give notice of trademark and other infringements
                that you think occur on the Service.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Notices and Questions
                </a>
              </li>
              <p>
                You agree we may provide you notices, including of updated terms
                and conditions, by posting notice on the home page of the
                Service, changing the date at the beginning of these Terms or by
                other reasonable means that we may elect, such as to the email
                address you provided.{" "}
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Links by You to the Service
                </a>
              </li>
              <p>You may link to our Service, subject to some basic rules.</p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Linked-To Websites; Advertisements; Dealings with Third
                  Parties
                </a>
              </li>
              <p>
                We are not responsible for third parties or their content,
                advertisement(s), apps, sites, products and/or services. We may
                make advertisements and third-party content or services
                available to you on or via our Service, which we do not control.
                Use caution when dealing with third parties.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Wireless and Location-Based Features
                </a>
              </li>
              <p>
                Wireless carrier charges may apply to use of the Service via
                wireless networks or Devices.{" "}
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Dispute Resolution
                </a>
              </li>
              <p>The procedure for dealing with disputes is set forth here.</p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Disclaimer of Representations, Warranties and Conditions
                </a>
              </li>
              <p>
                We disclaim warranties to the extent permitted by applicable
                law, and provide the Service “As Is”.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Limitations of our Liability
                </a>
              </li>
              <p>
                Details with respect to our liability to you are set forth here.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Waiver of Injunctive or Other Equitable Relief
                </a>
              </li>
              <p>You waive equitable or injunctive relief.</p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Updates to Terms
                </a>
              </li>
              <p>
                These Terms and Additional Terms posted on the Service at each
                time of use apply to that use, and the Terms may be
                prospectively updated as our Service evolves. Posting of new
                Terms on the Service is notice to you thereof.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  General Provisions
                </a>
              </li>
              <p>
                You agree to various other terms and conditions, which you
                should read here, including regarding (a) our control and
                discretion; (b) your indemnity of us; (c) accessing the Service
                from outside of the United States, Canada and/or EU; (d)
                enforcement and interpretation of these Terms; (e)
                communications with us; (f) investigations, cooperation with law
                enforcement, termination and survival; (g) limit on assignment
                and delegation of rights and obligations; (h) how waivers may be
                made; (i) some special notices for residents of California; and
                (j) your responsibility for your connectivity and access.
              </p>
              <li>
                <a href="https://en.caillou.com/terms-of-use">
                  Terms Applicable For Apple iOS and Microsoft Windows
                </a>
              </li>
              <p>
                There are some other things you should know if you are accessing
                or using the Service through an Apple or Windows Phone Device.
              </p>
            </ul>
            <h1>Full Details of the Terms of Use</h1>
            <ul>
              <li className="red-li">
                Service Content, Ownership, Limited License and Rights of Others
              </li>
              <li>Content.</li>
              <p>
                The Service contains a variety of: (i) materials and other items
                relating to LineConsultant, and its products and services, and
                similar items from our licensors and other third parties,
                including all layout, information, articles, posts, text, data,
                files, images, scripts, designs, graphics, button icons,
                instructions, illustrations, photographs, audio clips, music,
                sounds, pictures, videos, advertising copy, URLs, technology,
                software, interactive features, the “look and feel” of the
                Service, and the compilation, assembly, and arrangement of the
                materials of the Service and any and all copyrightable material
                (including source and object code); (ii) trademarks, trade
                dress, logos, trade names, service marks, and/or trade
                identities of various parties, including those of LineConsultant
                (collectively, <span>“Trademarks”</span>); and (iii) other forms
                of intellectual property (all of the foregoing, collectively 
                <span>“Content”</span>).
              </p>
              <li>Ownership.</li>
              <p>
                The Service (including past, present, and future versions) and
                the Content are owned or controlled by LineConsultant, our
                licensors or certain other third parties. All right, title, and
                interest in and to the Service (or any part thereof) and the
                Content (or any part thereof) , including any and all updates,
                modifications, adaptations, translations, customizations or
                derivative works of any of the foregoing, is the property of
                LineConsultant or our licensors or certain other third parties,
                and is protected by domestic and international copyright,
                trademark, trade dress, patent, or other intellectual property
                and unfair competition rights and laws to the fullest extent
                possible. LineConsultant owns the copyright in the selection,
                compilation, assembly, arrangement, and enhancement of the
                Content and the Service.
              </p>
              <li>Limited License.</li>
              <p>
                Subject to your strict compliance with these Terms and any
                Additional Terms, LineConsultant grants you a limited,
                non-exclusive, revocable, non-assignable, personal, and
                non-transferable license to: (i) download (temporary storage
                only), display, view, use, play, and/or print one copy of the
                Content (excluding source and object code in raw form or
                otherwise, other than as made available to access and use to
                enable display and functionality) on a personal computer, mobile
                phone or other wireless device, or other Internet enabled device
                (each, a <span>“Device”</span>) for your personal,
                non-commercial use only, and (ii) to use certain Content that we
                may from time to time make available on the Service explicitly
                for you for use as part of your User-Generated Content (defined
                below) <span>(“LineConsultant Licensed Elements”),</span>
                but only for such purposes as may be explicitly stated at the
                time that the LineConsultant Licensed Elements are made
                available on the Service; but we and our licensors and certain
                other third parties, as the case may be, retain ownership of
                such LineConsultant Licensed Elements. The foregoing limited
                license: (i) does not give you any ownership of, or any other
                intellectual property interest in, the Service (or any part
                thereof) or the Content (or any part thereof); and (ii) may be
                immediately suspended or terminated for any reason, in
                LineConsultant’s sole discretion, and without advance notice or
                liability. In some instances, we may permit you to have greater
                access to and use of Content and/or LineConsultant Licensed
                Elements, subject to certain Additional Terms.
              </p>
              <li>The Rights of Others.</li>
              <p>
                When using the Service, you must respect the intellectual
                property and other rights of LineConsultant and others. Your
                unauthorized use of Content may violate copyright, trademark,
                privacy, publicity, communications, and other laws, and any such
                use may result in your personal liability, including potential
                criminal liability. If you believe that your work has been
                infringed by means of an improper posting or distribution of it
                via the Service.
              </p>
              <li className="red-li">Service and Content Use Restrictions</li>
              <li>Service Use Restrictions.</li>
              <p>
                You agree that you will not: (i) use the Service for any
                political or commercial purpose (including, without limitation,
                for purposes of advertising, soliciting funds, collecting
                product prices, and selling products); (ii) use any meta tags or
                any other “hidden text” utilizing any Trademarks; (iii) engage
                in any activities through or in connection with the Service that
                seek to attempt to or do harm any individuals or entities or are
                unlawful, offensive, obscene, lewd, lascivious, filthy, violent,
                threatening, bullying, harassing, or abusive, or that violate
                any right of any third party, or are otherwise objectionable to
                LineConsultant; (iv) reverse engineer, decompile, disassemble,
                reverse assemble, or modify any Service source or object code or
                any software or other products, services, or processes
                accessible through any portion of the Service; (v) engage in any
                activity that interferes with a user’s access to the Service or
                the proper operation of the Service, or otherwise causes harm to
                the Service, LineConsultant, or other users of the Service; (vi)
                interfere with or circumvent any security feature of the Service
                or any feature that restricts or enforces limitations on use of
                or access to the Service, the Content, or the User-Generated
                Content (defined below); (vii) harvest or otherwise collect or
                store any information (including personally identifiable
                information about other users of the Service, including email
                addresses, without the express consent of such users); (viii)
                attempt to gain unauthorized access to the Service, other
                computer systems or networks connected to the Service, through
                password mining or any other means; or (ix) otherwise violate
                these Terms or any Additional Terms.
              </p>
              <li>Content Use Restrictions.</li>
              <p>
                You also agree that, in using the Service: (i) you will not
                monitor, gather, copy, or distribute the Content (except as may
                be a result of standard search engine activity or use of a
                standard browser) on the Service by using any robot, rover,
                “bot”, spider, scraper, crawler, spyware, engine, device,
                software, extraction tool, or any other automatic device,
                utility, or manual process of any kind; (ii) you will not frame
                or utilize framing techniques to enclose any such Content
                (including any images, text, or page layout); (iii) you will
                keep intact all Trademark, copyright, and other intellectual
                property notices contained in such Content; (iv) you will not
                use such Content in a manner that suggests an unauthorized
                association with any of our or our licensors’ products,
                services, or brands; (v) you will not make any modifications to
                such Content (other than to the extent of your permitted use of
                the LineConsultant Licensed Elements, if applicable); (vi) you
                will not copy, modify, reproduce, archive, sell, lease, rent,
                exchange, create derivative works, translations or adaptations
                from, publish by hard copy or electronic means, publicly
                perform, display, disseminate, distribute, broadcast,
                retransmit, circulate or transfer to any third party or on any
                third-party application or website, or otherwise use or exploit
                such Content in any way for any purpose except as specifically
                permitted by these Terms or any Additional Terms or with the
                prior written consent of an officer of LineConsultant or, in the
                case of Content from a licensor, the owner of the Content; (vii)
                you will not alter transmission data without LineConsultant’s
                consent; and (viii) you will not insert any code or product to
                manipulate such Content in any way that adversely affects any
                user experience.
              </p>
              <li>Availability of Service and Content.</li>
              <p>
                LineConsultant may immediately suspend or terminate the
                availability of the Service and Content (and any elements and
                features of them), in whole or in part, for any reason, in
                LineConsultant’s sole discretion, and without advance notice or
                liability. We do not guarantee that our Service, or any Content
                on it, will always be available or be uninterrupted. Access to
                our Service is permitted on a temporary basis. We will not be
                liable to you if for any reason our Service and/or Content is
                unavailable at any time or for any period.
              </p>
              <li>
                Reservation of All Rights Not Granted as to Content and Service.
              </li>
              <p>
                These Terms and any Additional Terms include only narrow,
                limited grants of rights to Content and to use and access the
                Service. No right or license may be construed, under any legal
                theory, by implication, estoppel, industry custom, or otherwise.
                All rights not expressly granted to you are reserved by
                LineConsultant and its licensors and other third parties.{" "}
                <i>
                   Any unauthorized use of any Content or the Service for any
                  purpose is prohibited.
                </i>
              </p>
              <li className="red-li">Opening and Terminating Accounts</li>
              <p>
                To access or use some (or potentially all) of the features on
                the Service, you may be required to first register through our
                registration process that we make available through the Service.
                The Service’s practices governing any resulting collection, use,
                disclosure and management of your personal information are
                disclosed in our 
                <a href="https://en.caillou.com/terms-of-use">
                  Privacy & Cookies Policy.
                </a>
              </p>
              <p>
                If you register for any feature that requires a password and/or
                username, then you will select your own password at the time of
                registration (or we may send you an e-mail notification with a
                randomly generated initial password) and you agree that: (i) You
                will not use a username (or e-mail address) that is already
                being used by someone else, may impersonate another person,
                belongs to another person, violates the intellectual property or
                other right of any person or entity, or is offensive. We may
                reject the use of any password, username, or e-mail address for
                any other reason in our sole discretion; (ii) You will provide
                true, accurate, current, and complete registration information
                about yourself in connection with the registration process and,
                as permitted, to maintain and update it continuously and
                promptly to keep it accurate, current, and complete; (iii) You
                are solely responsible for all activities that occur under your
                account, password, and username – whether or not you authorized
                the activity; (iv) You are solely responsible for maintaining
                the confidentiality of your password and for restricting access
                to your Device so that others may not access any password
                protected portion of the Service using your name, username, or
                password; (v) You will immediately notify us of any unauthorized
                use of your account, password, or username, or any other breach
                of security; and (vi) You will not sell, transfer, or assign
                your account or any account rights.
              </p>
              <p>
                We will not be liable for any loss or damage (of any kind and
                under any legal theory) to you or any third party arising from
                your inability or failure for any reason to comply with any of
                the foregoing obligations.
              </p>
              <p>
                If any information that you provide, or if we have reasonable
                grounds to suspect that any information that you provide, is
                false, inaccurate, outdated, incomplete, or violates these
                Terms, any Additional Terms, or any applicable law, then we may
                suspend or terminate your account. We also reserve the more
                general and broad right to terminate your account or suspend or
                otherwise deny you access to it or its benefits – all in our
                sole discretion, for any reason, and without advance notice or
                liability.
              </p>
              <li className="red-li">
                Content You Submit and Community Usage Rules
              </li>
              <li>User-Generated Content.</li>
              <li>
                <span>General.</span> LineConsultant may now or in the future
                offer users of the Service the opportunity to create, build,
                post, upload, display, publish, distribute, transmit, broadcast,
                or otherwise make available on or submit through the Service
                (collectively, “submit”) messages, avatars, text, illustrations,
                files, images, graphics, photos, comments, responses, sounds,
                music, videos, information, content, ratings, reviews, data,
                questions, suggestions, personally identifiable information, or
                other information or materials and the ideas contained therein
                (collectively, but excluding LineConsultant Licensed Elements
                included therein, “User-Generated Content”). LineConsultant may
                allow you to do this through forums, blogs, message boards,
                contact us tools, email, and other communications functionality.
                Subject to the license you grant in these Terms, you retain
                whatever legal right, title, and interest that you have in your
                User-Generated Content, and you remain ultimately responsible
                for it.
              </li>
              <li>
                <span>Non-Confidentiality of Your User-Generated Content.</span>
                 Except as otherwise described in the Service’s posted Privacy &
                Cookies Policy or any Additional Terms, you agree that: (a) your
                User-Generated Content will be treated as non-confidential –
                regardless of whether you mark them “confidential,”
                “proprietary,” or the like – and will not be returned; and (b)
                LineConsultant does not assume any obligation of any kind to you
                or any third party with respect to your User-Generated Content.
                Upon LineConsultant’s request, you will furnish us with any
                documentation necessary to substantiate the rights to such
                content and to verify your compliance with these Terms or any
                Additional Terms. You acknowledge that the Internet and mobile
                communications may be subject to breaches of security and that
                you are aware that submissions of User-Generated Content may not
                be secure, and you will consider this before submitting any
                User-Generated Content and do so at your own risk. In your
                communications with LineConsultant, please keep in mind that we
                do not seek any unsolicited ideas or materials for products or
                services, or even suggested improvements to products or
                services, including, without limitation, ideas, concepts,
                inventions, or designs for music, websites, apps, books,
                scripts, screenplays, motion pictures, television shows,
                theatrical productions, software or otherwise (collectively, 
                <span>“Unsolicited Ideas and Materials</span>”). Any Unsolicited
                Ideas and Materials you post on or send to us via the Service
                are deemed User-Generated Content and licensed to us as set
                forth below. In addition, LineConsultant retains all of the
                rights held by members of the general public with regard to your
                Unsolicited Ideas and Materials. LineConsultant’s receipt of
                your Unsolicited Ideas and Materials is not an admission by
                LineConsultant of their novelty, priority, or originality, and
                it does not impair LineConsultant’s right to contest existing or
                future intellectual property rights relating to your Unsolicited
                Ideas and Materials.
              </li>
              <li>
                <span>
                  {" "}
                  License to LineConsultant of Your User-Generated Content.
                </span>
                 Except as otherwise described in any applicable Additional
                Terms (such as a contest official rules), which specifically
                govern the submission of your User-Generated Content, you grant
                to LineConsultant the non-exclusive, unrestricted,
                unconditional, unlimited, worldwide, irrevocable, perpetual, and
                cost-free right and license to access, use, copy, record,
                distribute, reproduce, disclose, sell, re-sell, sublicense
                (through multiple levels), display, publicly perform, transmit,
                publish, broadcast, translate, modify, adapt, make derivative
                works of, and otherwise use and exploit in any manner
                whatsoever, all or any portion of your User-Generated Content
                (and any adaptations, translations, or derivative works
                thereof), for any purpose whatsoever in all formats, on or
                through any means or medium now known or hereafter developed,
                and with any technology or devices now known or hereafter
                developed, and to advertise, market, and promote the same.
                Without limitation, the granted rights include the right to: (a)
                configure, host, index, cache, archive, store, digitize,
                compress, optimize, modify, reformat, edit, adapt, publish in
                searchable format, and remove such User-Generated Content and
                combine same with other materials, and (b) use any ideas,
                concepts, know-how, or techniques contained in any
                User-Generated Content for any purposes whatsoever, including
                developing, producing, and marketing products and/or services.
                You understand that in exercising such rights metadata, notices
                and content may be removed or altered, including copyright
                management information, and you consent thereto and represent
                and warrant you have all necessary authority to do so. In order
                to further effect the rights and license that you grant to
                LineConsultant to your User-Generated Content, you also hereby
                grant to LineConsultant, and agree to grant to LineConsultant,
                the unconditional, perpetual, irrevocable right to use and
                exploit your name, persona, and likeness in connection with any
                User-Generated Content, without any obligation or remuneration
                to you. Except as prohibited by law, you hereby waive, and you
                agree to waive, any moral rights (including attribution and
                integrity) that you may have in any User-Generated Content, even
                if it is altered or changed in a manner not agreeable to you. To
                the extent not waivable, you irrevocably agree not to exercise
                such rights (if any) in a manner that interferes with any
                exercise of the granted rights. You understand that you will not
                receive any fees, sums, consideration, or remuneration for any
                of the rights granted in this Section 4(A)(iii).
              </li>
              <li>
                <span>Exclusive Right to Manage Our Service.</span>
                 LineConsultant may, but will not have any obligation to,
                review, monitor, display, post, store, maintain, accept, or
                otherwise make use of, any of your User-Generated Content, and
                LineConsultant may, in its sole discretion, reject, delete,
                move, re-format, remove or refuse to post or otherwise make use
                of User-Generated Content without notice or any liability to you
                or any third party in connection with our operation of
                User-Generated Content venues in an appropriate manner. Without
                limitation, we may do so to address content that comes to our
                attention that we believe is offensive, obscene, lewd,
                lascivious, filthy, violent, harassing, defamatory, threatening,
                abusive, illegal or otherwise objectionable or inappropriate, or
                to enforce the rights of third parties or these Terms or any
                applicable Additional Terms.
              </li>
              <li>
                <span>
                  Representations and Warranties Related to Your User-Generated
                  Content.
                </span>
                 Each time you submit any User-Generated Content, you represent
                and warrant that you are at least the age of majority in the
                jurisdiction in which you reside or are the parent or legal
                guardian, or have all proper consents from the parent or legal
                guardian, of any minor who is depicted in or contributed to any
                User-Generated Content you submit, and that, as to that
                User-Generated Content: (a) you are the sole author and owner of
                the intellectual property and other rights to the User-Generated
                Content, or you have a lawful right to submit the User-Generated
                Content and grant LineConsultant the rights to it that you are
                granting by these Terms and any Additional Terms, all without
                any LineConsultant obligation to obtain consent of any third
                party and without creating any obligation or liability of
                LineConsultant; (b) the User-Generated Content is accurate; (c)
                the User-Generated Content does not and, as to LineConsultant’s
                permitted uses and exploitation set forth in these Terms, will
                not infringe any intellectual property or other right of any
                third party; and (d) the User-Generated Content will not violate
                these Terms (including the Rules) or any Additional Terms, or
                cause injury or harm to any person.
              </li>
              <li>
                <span>Enforcement.</span> LineConsultant has no obligation to
                monitor or enforce your intellectual property rights to your
                User-Generated Content, to the extent permitted by applicable
                law, you grant us the right to protect and enforce our rights to
                your User-Generated Content, including by bringing and
                controlling actions in your name and on your behalf (at
                LineConsultant’s cost and expense, to which you hereby consent
                and irrevocably appoint LineConsultant as your attorney-in-fact,
                with the power of substitution and delegation, which appointment
                is coupled with an interest).
              </li>
              <li>Community Usage Rules.</li>
              <p>
                As a user of the Service, these Community Usage Rules
                <span>(“Rules”)</span> are here to help you understand the
                conduct that is expected of members of the Service’s online
                communities
                <span>(“Communities”)</span>.
              </p>
              <li>
                <span>Nature of Rules.</span> Your participation in the
                Communities is subject to all of the Terms, including these
                Rules:
              </li>
              <li>
                <span>Your User-Generated Content.</span> All of your
                User-Generated Content either must be original to you or you
                must have all necessary rights in it from third parties in order
                to permit you to comply with these Terms and any Additional
                Terms. Your User-Generated Content should not contain any
                visible logos, phrases, or trademarks that belong to third
                parties. Do not use any User-Generated Content that belongs to
                other people and pass it off as your own; this includes any
                content that you might have found elsewhere on the Internet. If
                anyone contributes to your User-Generated Content or has any
                rights to your User-Generated Content, or if anyone appears or
                is referred to in the User-Generated Content, then you must also
                have their permission to submit such User-Generated Content to
                LineConsultant (for example, if someone has taken a picture of
                you and your friend, and you submit that photo to LineConsultant
                as your User-Generated Content, then you must obtain your
                friend’s and the photographer’s permission to do so.).
              </li>
              <li>
                <span>
                  Speaking of Photos: No Pictures, Videos, or Images of Anyone
                  Other Than You and Your Friends and Family.
                </span>
                 If you choose to submit photos to the Service, link to embedded
                videos, or include other images of real people, then make sure
                they are of you or of you and someone you know – and only if you
                have their express permission to submit it.
              </li>
              <li>
                <span>Act Appropriately.</span> All of your Service activities
                must be venue appropriate, as determined by us. Be respectful of
                others’ opinions and comments so we can continue to build
                Communities for everyone to enjoy. If you think your
                User-Generated Content might offend someone or be embarrassing
                to someone, then chances are it probably will and it doesn’t
                belong on the Service. Cursing, harassing, bullying, stalking,
                insulting comments, personal attacks, gossip, and similar
                actions are prohibited. Your User-Generated Content must not
                threaten, abuse, or harm others, and it must not include any
                negative comments that are connected to any prohibited grounds
                of discrimination such as race, national origin, gender, sexual
                orientation, or physical handicap. Your User-Generated Content
                must not be defamatory, slanderous, indecent, obscene,
                pornographic, or sexually explicit.
              </li>
              <li>
                <span>Do Not Use for Commercial or Political Purposes.</span>
                 Your User-Generated Content must not advertise or promote a
                product or service or other commercial activity, or a
                politician, public servant, or law.
              </li>
              <li>
                <span>Do Not Use for Inappropriate Purposes.</span> Your
                User-Generated Content must not promote any infringing, illegal,
                or other similarly inappropriate activity. User-Generated
                Content that constitutes “junk mail”, “spam”, “chain letters”,
                “pyramid schemes”, and other forms of solicitation, or the
                sending of commercial electronic messages is prohibited.
              </li>
              <li>
                <span>
                  Be Honest and Do Not Misrepresent Yourself or Your
                  User-Generated Content.
                </span>
                 Do not impersonate any other person, user, or company, and do
                not submit User-Generated Content that you believe may be false,
                fraudulent, deceptive, inaccurate, or misleading, or that
                misrepresents your identity or affiliation with a person or
                company. Do not forge any TCP/IP packet header or any part of
                the header information in any e-mail or newsgroup posting or
                provide false or misleading representations in the sender
                information, subject line, locator, or content of any electronic
                message.
              </li>
              <li>
                <span>Others Can See.</span> We hope that you will use the
                Communities to exchange information and content and have venue
                appropriate discussions with other members. However, please
                remember that the Communities are public or semi-public and
                User-Generated Content that you submit on the Service within a
                Community may be accessible and viewable by other users. Do not
                submit personally identifying information (e.g., first and last
                name together, password, phone number, address, credit card
                number, medical information, email address, or other personally
                identifiable information or contact information) on Community
                spaces and take care when disclosing this type of information to
                others.
              </li>
              <li>
                <span>Don’t Share Other Peoples’ Personal Information.</span>
                 Your User-Generated Content should not reveal another person’s
                address, phone number, e-mail address, social security or social
                insurance number, credit card number, medical information,
                financial information, or any other personally identifiable
                information unless you have the individual’s consent to do so.
              </li>
              <li>
                <span>
                  Don’t Damage the Service or Anyone’s Computers or Other
                  Devices.
                </span>
                 Your User-Generated Content must not submit viruses, Trojan
                horses, spyware, or any other technologies or malicious code
                that could impact the operation of the Service or any computer
                or other Device
              </li>
              <p>
                If you submit User-Generated Content that LineConsultant
                reasonably believes violates these Rules, then we may take any
                legally available action that we deem appropriate, in our sole
                discretion. However, we are not obligated to take any action not
                required by law. We may require, at any time, proof of the
                permissions referred to above in a form acceptable to us.
                Failure to provide such proof may lead to, among other things,
                the User-Generated Content in question being removed from the
                Service.
              </p>
              <li>
                <span>Your Interactions with Other Users; Disputes.</span>
                 You are solely responsible for your interaction with other
                users of the Service, whether online or offline. We are not
                responsible or liable for the conduct or content of any user. We
                reserve the right, but have no obligation, to monitor or become
                involved in disputes between you and other users. Exercise
                common sense and your best judgment in your interactions with
                others (e.g., when you submit any personal or other information)
                and in all of your other online activities.
              </li>
              <li className="red-li">
              Procedure For Alleging Copyright Infringement
              </li>
              <li>Notice.</li>
              <p>
                LineConsultant will respond appropriately to notices of alleged
                copyright infringement that comply with applicable laws (for
                example, in the United States, the U.S. Digital Millennium
                Copyright Act (“DMCA”) and in England and Wales the Copyright,
                Designs and Patents Act 1988 (“CDPA”)), as set forth below. If
                you own a copyright in a work (or represent such a copyright
                owner) and believe that your (or such owner’s) copyright in that
                work has been infringed by an improper posting or distribution
                of it via the Service, then you may send us a written notice
                that includes all the following:
              </p>
              <li>
                a legend or subject line that says: “DMCA/CDPA Copyright
                Infringement Notice”;
              </li>
              <li>
                a description of the copyrighted work that you claim has been
                infringed or, if multiple copyrighted works are covered by a
                single notification, a representative list of such works;
              </li>
              <li>
                a description of where the material that you claim is infringing
                or is the subject of infringing activity is located that is
                reasonably sufficient to permit us to locate the material
                (please include the URL or page of the Service on which the
                material appears);
              </li>
              <li>
                your full name, address, telephone number and email address;
              </li>
              <li>
                a statement by you that you have a good faith belief that use of
                the material in the manner complained of is not authorized by
                the copyright owner, its agent, or the law;
              </li>
              <li>
                a statement by you, made under penalty of perjury if you reside
                in the U.S. and in good faith and to the best of your knowledge
                if you reside in the EU, that all the information in your notice
                is accurate, and that you are the copyright owner (or, if you
                are not the copyright owner, then your statement must indicate
                that you are authorized to act on the behalf of the owner of an
                exclusive right that is allegedly infringed); and
              </li>
              <li>your electronic or physical signature.</li>
              <li className="red-li">
                  Procedure For Alleging Infringement of Other Intellectual
                  Property
              </li>
              <p>
                If you own intellectual property other than copyrights and
                believe that your intellectual property has been infringed by an
                improper posting or distribution of it via the Service, then you
                may send us a written notice to the addresses set forth above
                that includes all the following:
              </p>
              <li>
                a legend or subject line that says: “Intellectual Property
                Infringement Notice”;
              </li>
              <li>
                a description of the intellectual property that you claim has
                been infringed;
              </li>
              <li>
                a description of where the material that you claim is infringing
                or is the subject of infringing activity is located that is
                reasonably sufficient to permit us to locate the material
                (please include the URL or page of the Service on which the
                material appears);
              </li>
              <li>
                your full name, address, telephone number and email address;
              </li>
              <li>
                a statement by you that you have a good faith belief that use of
                the material in the manner complained of is not authorized by
                the owner of the intellectual property, its agent, or the law;
              </li>
              <li>
                a statement by you, made under penalty of perjury if you reside
                in the U.S. and in good faith and to the best of your knowledge
                if you reside in the EU, that all the information in your notice
                is accurate, and that you are the owner of the intellectual
                property at issue (or, if you are not the owner, then your
                statement must indicate that you are authorized to act on the
                behalf of the owner of the intellectual property that is
                allegedly infringed); and
              </li>
              <li>your electronic or physical signature.</li>
              <p>
                We will act on such notices in our sole discretion. Any user of
                the Service that fails to respond satisfactorily to
                LineConsultant with regard to any such notice is subject to
                suspension or termination. We may send the information that you
                provide in your notice to the person who provided the allegedly
                infringing material.
              </p>
              <li className="red-li">
                Notices and Questions
              </li>
              <p>
                You agree that: (i) we may give you notices of new, revised or
                changed terms and other important matters by prominently posting
                notice on the homepage of the Service, or in another reasonable
                manner that we may elect; and (ii) we may contact you by mail or
                email sent to the address provided by you. You agree to promptly
                notify us if you change your email or mailing address by
                updating your account information.
              </p>
              <p>
                If you have a question regarding using the Service, you may
                contact us at 
                <a href="mailto:contact@LineConsultant.com.">
                  contact@LineConsultant.com.
                </a>
              </p>
              <li className="red-li">
                Links by You to the Service
              </li>
              <p>
                We grant you a limited, non-exclusive, revocable,
                non-assignable, personal, and non-transferable license to create
                hyperlinks to the Service, so long as: (a) the links only
                incorporate text, and do not use any Trademarks, (b) the links
                and the content on your website do not suggest any affiliation
                with LineConsultant or cause any other confusion or damage our
                reputation or take advantage of it, and (c) the links and the
                content on your website do not portray LineConsultant or its
                products or services in a false, misleading, derogatory, or
                otherwise offensive matter, and do not contain content that is
                unlawful, offensive, obscene, lewd, lascivious, filthy, violent,
                threatening, harassing, or abusive, or that violate any right of
                any third party or are otherwise objectionable to
                LineConsultant. LineConsultant reserves the right to suspend or
                prohibit linking to the Service for any reason, in its sole
                discretion, without advance notice or any liability of any kind
                to you or any third party.
              </p>
              <li className="red-li">
                
                  Linked-To Websites; Advertisements; Dealings with Third
                  Parties
                
              </li>
              <li>Linked Services, Advertisements.</li>
              <p>
                The Service may contain links, as part of third-party ads on the
                Service or otherwise, to or from third-party websites
                <span>(“Linked Services”),</span> including websites operated by
                advertisers, licensors, licensees, and certain other third
                parties who may have business relationships with LineConsultant.
                LineConsultant may have no control over the content, operations,
                policies, terms, or other elements of Linked Services, and
                LineConsultant does not assume any obligation to review any
                Linked Services. LineConsultant does not endorse, approve, or
                sponsor any Linked Services, or any third-party content,
                advertising, information, materials, products, services, or
                other items. Furthermore, LineConsultant is not responsible for
                the quality or delivery of the products or services offered,
                accessed, obtained by or advertised at such Services. Finally,
                to the extent permitted by law, LineConsultant will under no
                circumstances be liable for any direct, indirect, incidental or
                special loss or other damage, whether arising from negligence,
                breach of contract, defamation, infringement of copyright or
                other intellectual property rights, caused by the exhibition,
                distribution or exploitation of any information or content
                contained within these third-party Linked Services. Any
                activities you engage in connection with any of the same are
                subject to the privacy and other policies, terms, and conditions
                of use and/or sale, and rules issued by the operator of the
                Linked Services. LineConsultant disclaims all liability in
                connection therewith.
              </p>
              <li>Dealings with Third Parties.</li>
              <p>
                Any interactions, correspondence, transactions, and other
                dealings that you have with any third parties found on or
                through the Service (including on or via Linked Services or
                advertisements) are solely between you and the third party
                (including issues related to the content of third-party
                advertisements, payments, delivery of goods, warranties
                (including product warranties), privacy and data security, and
                the like). LineConsultant disclaims all liability in connection
                therewith.
              </p>
              <li className="red-li">
                Wireless and Location-Based Features
              </li>
              <li>Wireless Features.</li>
              <p>
                The Service may offer certain features and services that are
                available to you via your wireless Device. These features and
                services may include the ability to access the Service’s
                features and upload content to the Service, receive messages
                from the Service, and download applications to your wireless
                Device (collectively, <span> “Wireless Features”</span> ).
                Standard messaging, data, and other fees may be charged by your
                carrier to participate in Wireless Features. Fees and charges
                may appear on your wireless bill from your pre-paid balance.
                Your carrier may prohibit or restrict certain Wireless Features
                and certain Wireless Features may be incompatible with your
                carrier or wireless Device. You should check with your carrier
                to find out what plans are available and how much they cost.
                Contact your carrier with questions regarding these issues.
              </p>
              <li>Terms of Wireless Features.</li>
              <p>
                With respect to the Wireless Features for which you are
                registered, we may send communications to your wireless Device
                regarding us or other parties. Further, we may collect
                information related to your use of the Wireless Features. If you
                have registered via the Service for Wireless Features, then you
                agree to notify us of any changes to your wireless contact
                information (including phone number) and update your accounts on
                the Service to reflect the changes.
              </p>
              <li>Location-Based Features.</li>
              <p>
                If you have enabled GPS, geo-location or other location-based
                features on any mobile app(s) or feature(s), you acknowledge
                that your Device location will be tracked and may be shared with
                others consistent with the mobile app(s) or feature(s) allow for
                you to disable location-based features or manage preferences
                related to them. However, you can terminate Device location
                tracking by us by Uninstalling any mobile app(s) or feature(s).
                The location-based services offered in connection with our
                mobile app(s) or feature(s) are for individual use only and
                should not be used or relied on as an emergency locator system,
                used while driving or operating vehicles, or used in connection
                with any hazardous environments requiring fail-safe performance,
                or any other situation in which the failure or inaccuracy of use
                of the location-based services could lead directly to death,
                personal injury, or severe physical or property damage. The
                location-based services are not suited or intended for family
                finding purposes, fleet tracking, or any other type of business
                or enterprise use – other products exist today that may be used
                specifically for these purposes.
              </p>
            </ul>
          </div>
        </div>
      </div>
      <div className="info-container">
        <div className="info">
          <div className="info-text">
            <h2>
              Interested To <br /> Get Our Featured Service{" "}
            </h2>
          </div>
          <div className="info-btn">
            <Link to={"/shop"}>Get Started Now</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
